import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/orderings/employee-cost/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const employeeCost = {
  get: apiPathFunc(pathBase),
} as const;
